/* eslint-disable no-tabs */
// const pdfMaker = require('pdfmake')
import moment from 'moment';
import campaignConfig from './config';
import campaignPDF from './campaignPDF'
import countries from '../../../../static/sources/countries';
import config from '@/config';
import utils from '../../../utils';
import * as pdfMake from 'pdfmake/build/pdfmake.js';
// import * as pdfFonts from 'pdfmake/build/vfs_fonts.js';
// pdfMake.vfs = pdfFonts.pdfMake.vfs;
// import * as pdfFonts from './custom-fonts';
// const vfs = pdfFonts.pdfMake.vfs;
// setTimeout(() => {
//   pdfMake.vfs = vfs
// }, 100)
export default {
  // Campaign Brief Old Function - Not Using Now
  getPdfInBase64 (campaign) {
    let campaignModelSections = campaignConfig.campaignModelSections
    let copyrightText = 'All Rights Reserved. © Kobe Global Technologies Pte Ltd'
    let showBudget = false
    let doc = {}
    doc = {
      content: [
        {
          image: config.kobeLogoDataURL,
          width: 50,
          style: 'logo'
        }
      ],
      styles: {
        header: {
          fontSize: 20,
          bold: true
        },
        sectionTitle: {
          bold: true,
          fontSize: 18,
          marginTop: 20,
          padding: 5
        },
        options: {
          fontSize: 14,
          marginLeft: 15,
          marginTop: 15
        },
        logo: {
          alignment: 'right'
        },
        attributesTitle: {
          marginLeft: 15,
          marginBottom: 5
        },
        attributes: {
          marginLeft: 15,
          marginBottom: 5
        },
        exportTime: {
          fontSize: 9,
          alignment: 'center',
          color: '#A9A9A9'
        },
        copyright: {
          fontSize: 12,
          color: '#808080',
          marginTop: 20
        },
        image: {
          marginBottom: 15,
          maxWidth: 200
        }
      }
    };
    let sectionsColumns = { columns: [] };

    for (const item of campaignModelSections) {
      // loop according to campaign Model Sections from the config
      if (item.type === campaignConfig.campaignModelSectionType.BILLING_DETAILS) {
        if (showBudget) {
          // show or hide Billing Details Title
          doc.content.push({ text: item.title + '\n\n', style: 'sectionTitle' });
        }
      } else {
        doc.content.push({ text: item.title + '\n\n', style: 'sectionTitle' });
      }
      for (const field of item.content) {
        // for each section
        if (field.name === 'gender') {
          // for gender case extract the Gender Text
          let genderText = getDisplayValueFromSelect(field.value, campaign[field.name]);
          sectionsColumns.columns.push({ text: field.label, style: 'attributesTitle' });
          sectionsColumns.columns.push({ text: genderText + '\n\n', style: 'attributes' });
        } else if (field.name === 'budget') {
          if (showBudget) {
            sectionsColumns.columns.push({ text: field.label, style: 'attributesTitle' });
            sectionsColumns.columns.push({ text: `${campaign[field.name]}\n\n`, style: 'attributes' });
          }
        } else if (
          field.name === 'actionRequired_time' ||
          field.name === 'actionRequired_action' ||
          field.name === 'actionRequired_receive' ||
          field.name === 'actionRequired_value'
        ) {
          // Hide action Required fields in PDF
          // if (hideRequiredActions()) {
          //   let actionRequiredText = getDisplayValueFromSelect(field.value, campaign[field.name])
          //   sectionsColumns.columns.push({text: field.label, style: 'attributesTitle'})
          //   sectionsColumns.columns.push({text: actionRequiredText + '\n\n', style: 'attributes'})
          // }
        } else if (field.name === 'angles') {
          // for influencer Experiences section
          let count = 0;
          for (let experiences of campaign[field.name]) {
            // construct Option Title
            // count = count + 1
            let optionTitle = field.label + ' ' + ++count;
            doc.content.push({ text: optionTitle + '\n\n', style: 'options' });
            let optionColumns = {
              columns: []
            };
            for (let exp in experiences) {
              let experiencesTemplate = field.template;
              let imageList = {
                color: 'blue',
                ul: []
              };
              if (exp === 'sample_images') {
                // for Image Case
                optionColumns.columns.push({ text: 'Image/Video Inspirations' + '\n\n', style: 'attributesTitle' });
                for (let image of experiences[exp]) {
                  let url = constructImageURL(image);
                  toDataURL(url).then(dataURL => {
                    imageList.ul.push({ image: dataURL, width: 200, style: 'image' });
                  });
                }
                optionColumns.columns.push(imageList);
                doc.content.push(optionColumns);
                optionColumns = { columns: [] };
              } else {
                let otherExperiences = experiencesTemplate.filter(expTmp2 => expTmp2.name === exp);
                for (const otherExp of otherExperiences) {
                  optionColumns.columns.push({ text: otherExp.label, style: 'attributesTitle' });
                  optionColumns.columns.push({ text: experiences[exp] + '\n\n', style: 'attributes' });
                }
                doc.content.push(optionColumns);
                optionColumns = { columns: [] };
              }
            }
          }
        } else {
          sectionsColumns.columns.push({ text: field.label, style: 'attributesTitle' });
          sectionsColumns.columns.push({ text: `${campaign[field.name]}\n\n`, style: 'attributes' });
        }
        doc.content.push(sectionsColumns);
        sectionsColumns = { columns: [] };
      }
    }

    doc.content.push({ text: 'Generated at: ' + moment().format('MMMM Do YYYY, h:mm:ss a'), style: 'exportTime' });
    doc.content.push({ text: copyrightText, alignment: 'center', style: 'copyright' });

    return new Promise(function(resolve, reject) {
      const pdfDocGenerator = pdfMake.createPdf(doc)

      pdfDocGenerator.getBase64(data => {
        if (data !== null) {
          resolve(data)
        } else {
          reject('Can not convert')
        }
      })
    })

    // Functions
    function getDisplayValueFromSelect(selectList, value) {
      var selectedOption = selectList.find(option => {
        return option.value === value;
      });
      return selectedOption ? selectedOption.text : '-';
    }

    function constructImageURL(imageName) {
      return 'https://s3-ap-southeast-1.amazonaws.com/uat.app.getkobe.com/' + imageName;
    }

    function toDataURL(url) {
      return fetch(url)
        .then(response => response.blob())
        .then(
          blob =>
            new Promise((resolve, reject) => {
              const reader = new FileReader();
              reader.onloadend = () => resolve(reader.result);
              reader.onerror = reject;
              reader.readAsDataURL(blob);
            })
        )
    }
  },
  generatePDF(pdfObject) {
    return new Promise(function(resolve, reject) {
      try {
        setTimeout(async function() {
          pdfMake.fonts = {
            Arial: {
              normal: 'https://s3-ap-southeast-1.amazonaws.com/uat.app.getkobe.com/5ae49705-f547-4188-937a-97650517199c.TTF',
              bold: 'https://s3-ap-southeast-1.amazonaws.com/uat.app.getkobe.com/5ae49705-f547-4188-937a-97650517199c.TTF',
              italics: 'https://s3-ap-southeast-1.amazonaws.com/uat.app.getkobe.com/5ae49705-f547-4188-937a-97650517199c.TTF'
            }
          }
          const pdfDocGenerator = pdfMake.createPdf(pdfObject)
          let contractFile = await new Promise((resolve) => {
            pdfDocGenerator.getDataUrl((dataUrl) => {
              let response = utils.func.dataURLtoFile(dataUrl, 'bfs.pdf')
              resolve(response)
            })
          })
          if (contractFile) {
            resolve(contractFile)
          } else {
            reject('Can not convert')
          }
          // pdfDocGenerator.getBase64(data => {
          //   if (data !== null) {
          //     resolve(data)
          //   } else {
          //     reject('Can not convert')
          //   }
          // })
        }, 1000)
      } catch (error) {
        reject(error)
        console.log(error)
      }
    })
  },
  generateBasePDF(pdfObject) {
    return new Promise(function(resolve, reject) {
      try {
        setTimeout(async function() {
          pdfMake.fonts = {
            Arial: {
              normal: 'https://s3-ap-southeast-1.amazonaws.com/uat.app.getkobe.com/5ae49705-f547-4188-937a-97650517199c.TTF',
              bold: 'https://s3-ap-southeast-1.amazonaws.com/uat.app.getkobe.com/5ae49705-f547-4188-937a-97650517199c.TTF',
              italics: 'https://s3-ap-southeast-1.amazonaws.com/uat.app.getkobe.com/5ae49705-f547-4188-937a-97650517199c.TTF'
            }
          }
          const pdfDocGenerator = pdfMake.createPdf(pdfObject)
          pdfDocGenerator.getBase64(data => {
            if (data !== null) {
              resolve(data)
            } else {
              reject('Can not convert')
            }
          })
        }, 1000)
      } catch (error) {
        reject(error)
        console.log(error)
      }
    })
  },
  downloadPDF(pdfObject, fileName) {
    return new Promise(function(resolve, reject) {
      try {
        setTimeout(function() {
          pdfMake.fonts = {
            Arial: {
              normal: 'https://s3-ap-southeast-1.amazonaws.com/uat.app.getkobe.com/5ae49705-f547-4188-937a-97650517199c.TTF',
              bold: 'https://s3-ap-southeast-1.amazonaws.com/uat.app.getkobe.com/5ae49705-f547-4188-937a-97650517199c.TTF'
            }
          }
          const pdfDocGenerator = pdfMake.createPdf(pdfObject)
          pdfDocGenerator.download(`${fileName}.pdf`);
        }, 1000)
      } catch (error) {
        reject(error)
        console.log(error)
      }
    })
  },
  convertPDFLayout(campaignModelSections, campaignData, showBudget, copyrightText) {
    let campaignModelSectionType = campaignConfig.campaignModelSectionType
    let doc = {};
    doc = {
      footer: function(currentPage, pageCount) {
        return {
          margin: 10,
          columns: [
            {
              fontSize: 9,
              text: [
                {
                  text: '--------------------------------------------------------------------------' +
                  '\n',
                  margin: [0, 20]
                },
                {
                  text: currentPage.toString() + ' of ' + pageCount
                }
              ],
              alignment: 'center'
            }
          ]
        };
        // return currentPage.toString() + ' of ' + pageCount;
      },
      content: [
        {
          image: config.kobeLogoDataURL,
          width: 60,
          style: 'logo'
        }
      ],
      styles: {
        header: {
          fontSize: 20,
          bold: true
        },
        footer: {
          alignment: 'center'
        },
        sectionTitle: {
          alignment: 'center',
          bold: true,
          fontSize: 18,
          marginTop: 20,
          // marginLeft: 9,
          marginBottom: 7,
          padding: 5
        },
        options: {
          alignment: 'left',
          bold: true,
          fontSize: 15,
          marginLeft: 13
        },
        logo: {
          alignment: 'center',
          marginBottom: 0
        },
        attributesTitle: {
          fontSize: 13,
          bold: true,
          // marginLeft: 15,
          marginBottom: 4
          // decoration: 'underline'
        },
        attributes: {
          // marginLeft: 15,
          marginBottom: 7,
          fontSize: 11
        },
        SmallBottomAttributes: {
          marginBottom: 3,
          fontSize: 11
        },
        customTitle: {
          marginLeft: 13
        },
        exportTime: {
          fontSize: 9,
          alignment: 'center',
          color: '#A9A9A9'
        },
        copyright: {
          fontSize: 12,
          color: '#808080',
          marginTop: 20
        },
        image: {
          marginBottom: 15,
          maxWidth: 200
        },
        canvasImage: {
          alignment: 'left'
        },
        kicLabel: {
          marginTop: 20,
          alignment: 'center'
        },
        top1: {
          marginTop: 0
        },
        sampleImage: {
          marginBottom: 10
        },
        spacingBottom: {
          marginBottom: 10
        }
      },
      defaultStyle: {
        font: 'Arial'
      }
    };
    /**
     * Nyein - commented out some codes to roll-back single view if needed
     */
    // let kicImage = [];
    let sectionsColumns = { columns: [] };
    for (const item of campaignModelSections) {
      // loop according to campaign Model Sections from the config
      if (item.type === campaignModelSectionType.BILLING_DETAILS) {
        if (showBudget) {
          // show or hide Billing Details Title
          doc.content.push({ text: item.title + '\n\n', style: 'sectionTitle' });
        }
      } else {
        if (item.type === campaignModelSectionType.CONTENT_ANGLE || item.type === campaignModelSectionType.INFLUENCER_SELECTION) {
          doc.content.push({ text: item.title + '\n\n', style: 'sectionTitle', pageBreak: 'before' });
        } else {
          doc.content.push({ text: item.title + '\n\n', style: 'sectionTitle' });
        }
      }
      for (const field of item.content) {
        // for each section
        if (field.name === 'gender') {
          // for gender case extract the Gender Text
          let genderText = getDisplayValueFromSelect(field.value, campaignData[field.name]);
          if (genderText !== '-') {
            let attributeLists = {
              type: 'none',
              ul: []
            }
            attributeLists.ul.push({ text: field.label, style: 'attributesTitle' })
            attributeLists.ul.push({ text: genderText + '\n\n', style: 'attributes' })
            sectionsColumns.columns.push(attributeLists)
          }
          // sectionsColumns.columns.push({ text: field.label, style: 'attributesTitle' });
          // sectionsColumns.columns.push({ text: genderText + '\n\n', style: 'attributes' });
        } else if (field.name === 'budget') {
          if (showBudget && campaignData[field.name]) {
            let attributeLists = {
              type: 'none',
              ul: []
            }
            attributeLists.ul.push({ text: field.label, style: 'attributesTitle' })
            attributeLists.ul.push({ text: `${campaignData[field.name]}\n\n`, style: 'attributes' })
            sectionsColumns.columns.push(attributeLists)
            // sectionsColumns.columns.push({ text: field.label, style: 'attributesTitle' });
            // sectionsColumns.columns.push({ text: `${campaignData[field.name]}\n\n`, style: 'attributes' });
          }
        } else if (
          field.name === 'actionRequired_time' ||
          field.name === 'actionRequired_action' ||
          field.name === 'actionRequired_receive' ||
          field.name === 'actionRequired_value'
        ) {
          // Nyein - commented out to remove (can rollback if needed)
          // Hide action Required fields in PDF
          // if (this.hideRequiredActions()) {
          //   let actionRequiredText = getDisplayValueFromSelect(field.value, campaignData[field.name])
          //   let attributeLists = {
          //     type: 'none',
          //     ul: []
          //   }
          //   attributeLists.ul.push({ text: field.label, style: 'attributesTitle' })
          //   attributeLists.ul.push({ text: actionRequiredText + '\n', style: 'attributes' })
          //   sectionsColumns.columns.push(attributeLists);
          //   // sectionsColumns.columns.push({text: field.label, style: 'attributesTitle'})
          //   // sectionsColumns.columns.push({text: actionRequiredText + '\n\n', style: 'attributes'})
          // }
        } else if (field.name === 'angles') {
          // for influencer Experiences section
          let count = 0;
          for (let experiences of campaignData[field.name]) {
            let optionColumns = {
              columns: []
            };
            for (let exp in experiences) {
              if (exp === 'option_name') {
                // construct Option Title
                // count = count + 1
                let optionTitle = field.label + ' ' + ++count;
                doc.content.push({ text: `${optionTitle}: ${experiences[exp]}\n\n`, style: 'options' });
                // add context manually to fix old data
                if (experiences['context']) {
                  let attributeLists = {
                    type: 'none',
                    ul: []
                  }
                  attributeLists.ul.push({ text: 'Campaign Context', style: 'attributesTitle' })
                  attributeLists.ul.push({ text: experiences['context'] + '\n\n\n', style: 'attributes' })
                  doc.content.push(attributeLists)
                }
              }
              let experiencesTemplate = field.template;
              // Nyein - commented out to remove (can rollback if needed)
              // let imageList = {
              //   color: 'blue',
              //   ul: []
              // };
              // if (exp === 'sample_images') {
              //   // for Image Case
              //   optionColumns.columns.push({ text: 'Image Inspirations' + '\n\n', style: 'attributesTitle' });
              //   for (let image of experiences[exp]) {
              //     let url = constructImageURL(image);
              //     toDataURL(url).then(dataURL => {
              //       imageList.ul.push({ image: dataURL, width: 200, style: 'image' });
              //     });
              //   }
              //   optionColumns.columns.push(imageList);
              //   doc.content.push(optionColumns);
              //   optionColumns = { columns: [] };
              // }
              // if (exp === 'formats') {
              //   // for multiple formats
              //   for(const exp2 of experiences[exp]) {
              //     let otherExperiences = experiencesTemplate.filter(expTmp2 => expTmp2.name === exp);
              //     for (const otherExp of otherExperiences) {
              //       optionColumns.columns.push({ text: otherExp.label, style: 'attributesTitle' });
              //       optionColumns.columns.push({ text: experiences[exp] + '\n\n', style: 'attributes' });
              //     }
              //     if (exp2 === 'sample_images') {
              //       // for Image Case
              //       optionColumns.columns.push({ text: 'Image Inspirations' + '\n\n', style: 'attributesTitle' });
              //       for (let image of experiences[exp]) {
              //         let url = constructImageURL(image);
              //         toDataURL(url).then(dataURL => {
              //           imageList.ul.push({ image: dataURL, width: 200, style: 'image' });
              //         });
              //       }
              //       optionColumns.columns.push(imageList);
              //       doc.content.push(optionColumns);
              //       optionColumns = { columns: [] };
              //     }
              //   }
              // } else {
              let otherExperiences = experiencesTemplate.filter(expTmp2 => expTmp2.name === exp);
              for (const otherExp of otherExperiences) {
                if (otherExp.name === 'formats') {
                  for (let formatIndex in experiences[exp]) { // loop formats
                    // optionColumns.columns.push({ text: '\n' + `Angle ${parseInt(formatIndex) + 1}` + '\n', style: ['attributesTitle', 'customTitle'] });
                    // doc.content.push(optionColumns);
                    let isAnyFormatFieldAdded = false
                    optionColumns = { columns: [] };
                    for (let exp2 in experiences[exp][formatIndex]) { // loop format fields
                      let experiencesTemplate2 = otherExp.template[0];
                      let otherExperiences2 = experiencesTemplate2.filter(expTmp2 => expTmp2.name === exp2);
                      for (const otherExp2 of otherExperiences2) {
                        if (otherExp2.name === 'sample_images' && experiences[exp][formatIndex][exp2].length > 0) {
                          isAnyFormatFieldAdded = true
                          // for Image Case
                          optionColumns = { columns: [] };
                          optionColumns.columns.push({ text: 'Image/video Inspirations', style: ['attributesTitle', 'customTitle'] });
                          doc.content.push(optionColumns);
                          optionColumns = { columns: [] };
                          let attributeLists = {
                            type: 'none',
                            ul: []
                          }
                          // attributeLists.ul.push({ text: 'Image Inspirations', style: ['attributesTitle'] })
                          // let imageList = {
                          //   type: 'none',
                          //   color: 'blue',
                          //   ul: []
                          // };
                          for (let image of experiences[exp][formatIndex][exp2]) { // loop sample images
                            if (image.type === 'image' && checkIfImage(image.url)) {
                              let url = constructImageURL(image.url);
                              toDataURL(url).then(dataURL => {
                                attributeLists.ul.push({ image: dataURL, width: 200, style: ['sampleImage'] });
                              });
                            } else {
                              attributeLists.ul.push({ text: image.url, style: 'sampleImage', link: image.url });
                            }
                          }
                          // attributeLists.ul.push(imageList)
                          optionColumns.columns.push(attributeLists)
                          doc.content.push(optionColumns);
                          optionColumns = { columns: [] };
                          optionColumns.columns.push({ text: '', style: ['spacingBottom'] });
                          doc.content.push(optionColumns);
                          optionColumns = { columns: [] };
                        } else {
                          if ((typeof experiences[exp][formatIndex][exp2] === 'string' && experiences[exp][formatIndex][exp2] && experiences[exp][formatIndex][exp2] !== '-' && typeof experiences[exp][formatIndex][exp2] !== Array) ||
                          (typeof experiences[exp][formatIndex][exp2] === Array && experiences[exp][formatIndex][exp2].length > 0) ||
                          (otherExp2.name === 'mandatory' && experiences[exp][formatIndex][exp2].length > 0)) {
                            isAnyFormatFieldAdded = true
                            let attributeLists = {
                              type: 'none',
                              ul: []
                            }
                            attributeLists.ul.push({ text: otherExp2.label, style: 'attributesTitle' })
                            if (otherExp2.name === 'mandatory') {
                              attributeLists.ul.push({ text: experiences[exp][formatIndex][exp2].join(', '), style: 'SmallBottomAttributes' })
                            } else if (otherExp2.name === 'content_angle') {
                              attributeLists.ul.push({ text: experiences[exp][formatIndex][exp2], style: 'SmallBottomAttributes' })
                            } else {
                              attributeLists.ul.push({ text: experiences[exp][formatIndex][exp2], style: 'attributes' })
                            }
                            optionColumns.columns.push(attributeLists);
                            doc.content.push(optionColumns);
                            // optionColumns.columns.push({ text: otherExp2.label, style: 'attributesTitle' });
                            // optionColumns.columns.push({ text: experiences[exp][formatIndex][exp2] + '\n\n', style: 'attributes' });
                          }
                        }
                        doc.content.push(optionColumns);
                        if (optionColumns.columns.length > 1) {
                          optionColumns = { columns: [] };
                        }
                      }
                    }
                    if (isAnyFormatFieldAdded) {
                      doc.content.push({ canvas: [{ type: 'line', x1: 10, y1: 10, x2: 510 - 10, y2: 10, lineWidth: 0.01, lineColor: '#e1e1e1' }] });
                      doc.content.push({ text: '\n' });
                    }
                  }
                } else {
                  if (exp !== 'option_name' && exp !== 'context') { // option_name, context are added manually at top
                    if ((experiences[exp] && experiences[exp] !== '-' && typeof experiences[exp] !== Array) || (typeof experiences[exp] === Array && experiences[exp].length > 0)) {
                      let attributeLists = {
                        type: 'none',
                        ul: []
                      }
                      attributeLists.ul.push({ text: otherExp.label, style: 'attributesTitle' })
                      attributeLists.ul.push({ text: experiences[exp] + '\n\n', style: 'attributes' })
                      // if (exp === 'context') {
                      //   attributeLists.ul.push({ text: experiences[exp] + '\n\n\n', style: 'attributes' })
                      // } else {
                      //   attributeLists.ul.push({ text: experiences[exp] + '\n\n', style: 'attributes' })
                      // }
                      optionColumns.columns.push(attributeLists)
                      // optionColumns.columns.push({ text: otherExp.label, style: 'attributesTitle' });
                      // optionColumns.columns.push({ text: experiences[exp] + '\n\n', style: 'attributes' });
                    }
                  }
                }
                doc.content.push(optionColumns);
                optionColumns = { columns: [] };
              }
              // }
            }
          }
        } else if (field.name === 'kic') {
          if (campaignData[field.name] !== '' && typeof campaignData[field.name] === 'string') {
            sectionsColumns = { columns: [] };
            let attributeLists = {
              type: 'none',
              ul: []
            }
            let url = constructImageURL(campaignData[field.name]);
            toDataURL(url).then(dataURL => {
              attributeLists.ul.push({ text: field.label, style: 'attributesTitle' })
              attributeLists.ul.push({ image: dataURL, width: 300, style: 'canvasImage', link: url })
              // kicImage.push({ text: field.label, style: 'kicLabel' });
              // kicImage.push({ image: dataURL, width: 400, style: 'canvasImage', link: url });
            });
            sectionsColumns.columns.push(attributeLists);
          }
        } else if (field.name === 'vertical') {
          // Nyein - commented out to remove (can rollback if needed)
          // if (!this.isClient) {
          //   let attributeLists = {
          //     type: 'none',
          //     ul: []
          //   }
          //   attributeLists.ul.push({ text: field.label, style: 'attributesTitle' })
          //   // sectionsColumns.columns.push({ text: field.label, style: 'attributesTitle' });
          //   let verticalNames = this.selectedCampaignVertical.map(v => v.name)
          //   attributeLists.ul.push({ text: `${verticalNames.join(', ')}\n\n`, style: 'attributes' })
          //   sectionsColumns.columns.push(attributeLists);
          //   // sectionsColumns.columns.push({ text: `${verticalNames.join(', ')}\n\n`, style: 'attributes' });
          // }
        } else {
          if (field.name === 'campaignType' ||
          field.name === 'dont' ||
          field.name === 'visualMust' ||
          field.name === 'copyMust' ||
          field.name === 'ioNumbers') {
            // Nyein - commented out to remove (can rollback if needed)
            // if (this.hideRequiredActions()) {
            //   let attributeLists = {
            //     type: 'none',
            //     ul: []
            //   }
            //   attributeLists.ul.push({ text: field.label, style: 'attributesTitle' })
            //   attributeLists.ul.push({ text: `${campaignData[field.name]}\n\n`, style: 'attributes' })
            //   sectionsColumns.columns.push(attributeLists);
            //   // sectionsColumns.columns.push({ text: `${campaignData[field.name]}\n\n`, style: 'attributes' });
            // } else {
            //   sectionsColumns = { columns: [] };
            // }
          } else if (field.name === 'campaignBackground') {
            // Nyein - commented out to remove (can rollback if needed)
            // if (this.hideRequiredActions()) {
            let attributeLists = {
              type: 'none',
              ul: []
            }
            attributeLists.ul.push({ text: field.label, style: 'attributesTitle' })
            attributeLists.ul.push({ text: `${campaignData[field.name]}\n\n`, style: 'attributes' })
            sectionsColumns.columns.push(attributeLists);
            //   // sectionsColumns.columns.push({ text: `${campaignData[field.name]}\n\n`, style: 'attributes' });
            // } else {
            //   sectionsColumns = { columns: [] };
            // }
          } else {
            let addAttribute = true
            if (field.name === 'engagement') {
              if (campaignData[field.name] <= 0) {
                addAttribute = false
              }
            } else if (field.name === 'revenueCalculation') {
              addAttribute = false
            } else if (field.name === 'segment') {
              if (!campaignData[field.name]) {
                campaignData['segment'] = '-'
              }
            } else if (field.name === 'targetLocation') {
              if (Array.isArray(campaignData[field.name])) {
                campaignData['targetLocation'] = getCountryDisplayValueFromSelect(field.value, campaignData[field.name])
              }
            }
            if ((addAttribute && campaignData[field.name] && campaignData[field.name] !== '-' && typeof campaignData[field.name] !== 'object') || (typeof campaignData[field.name] === 'object' && campaignData[field.name].length > 0)) {
              let attributeLists = {
                type: 'none',
                ul: []
              }
              attributeLists.ul.push({ text: field.label, style: 'attributesTitle' })
              if (field.name === 'name' && typeof campaignData.campaignCode !== 'undefined') {
                attributeLists.ul.push({ text: `${campaignData[field.name]} (${campaignData.campaignCode})\n\n`, style: 'attributes' });
              } else {
                attributeLists.ul.push({ text: `${campaignData[field.name]}\n\n`, style: 'attributes' })
              }
              sectionsColumns.columns.push(attributeLists);
              // sectionsColumns.columns.push({ text: `${campaignData[field.name]}\n\n`, style: 'attributes' });
            }
          }
        }
        // if (field.name === 'kic') {
        //   console.log(sectionsColumns, 'for kic')
        // }
        doc.content.push(sectionsColumns);
        if (sectionsColumns.columns.length > 1) {
        // to show two columns in a row
          sectionsColumns = { columns: [] };
        }
      }
      sectionsColumns = { columns: [] };
    }
    // doc.content.push(kicImage);
    doc.content.push({ text: copyrightText, alignment: 'center', style: 'copyright' });
    doc.content.push({ text: 'Generated at: ' + moment().format('MMMM Do YYYY, h:mm:ss a'), style: 'exportTime' });

    // Functions
    function getDisplayValueFromSelect(selectList, value) {
      var selectedOption = selectList.find(option => {
        return option.value === value;
      });
      return selectedOption ? selectedOption.text : '-';
    }

    function getCountryDisplayValueFromSelect(selectList, value) {
      let countryLists = Object.assign([], countries)
      if (typeof value === 'string') return value
      var selectedOption = countryLists.filter(option => {
        return value.includes(option.code)
      });
      return selectedOption ? selectedOption.map(o => o.name).join(', ') : '-';
    }

    function constructImageURL(imageName) {
      return 'https://s3-ap-southeast-1.amazonaws.com/uat.app.getkobe.com/' + imageName;
    }
    function toDataURL(url) {
      return fetch(url)
        .then(response => response.blob())
        .then(
          blob =>
            new Promise((resolve, reject) => {
              const reader = new FileReader();
              reader.onloadend = () => resolve(reader.result);
              reader.onerror = reject;
              reader.readAsDataURL(blob);
            })
        )
    }
    function checkIfImage(url) {
      const images = ['jpg', 'JPG', 'jpeg', 'JPEG', 'png', 'PNG']
      let isImage = false
      images.map(img => {
        if (url.endsWith(img)) {
          isImage = true
        }
      })
      return isImage
    }
    return doc
  },
  async generateBFS(brandSheet) {
    let doc = campaignPDF.BFSConfig();
    // const campaignType = campaignConfig.campaignType
    const bfsTypes = campaignConfig.bfsTypes
    // -------------- if Story Tell ------------------
    if (brandSheet.type === bfsTypes.STORY_TELL) {
      doc.content = await campaignPDF.generateStoryTell(doc.content, brandSheet)
    }
    // -------------- if AOK ------------------
    if (brandSheet.type === 'AOK' || brandSheet.type === bfsTypes.AOK) {
      doc.content = await campaignPDF.generateAOK(doc.content, brandSheet)
    }
    // -------------- if Kobe Lite ------------------
    if (brandSheet.type === bfsTypes.KOBE_LITE) {
      doc.content = await campaignPDF.generateKobeLite(doc.content, brandSheet)
    }
    // -------------- if UGC ------------------
    if (brandSheet.type === bfsTypes.UGC) {
      doc.content = await campaignPDF.generateUGC(doc.content, brandSheet)
    }
    return doc
  },
  async generateAOK(content, brandSheet) {
    let url = utils.func.constructWebImageURL('/static/img/brand_sheet/aok_bg.png');
    let dataURL = await utils.func.toDataURL(url)
    content.push({
      text: 'KOBE Uncut - BRAND FACT SHEET',
      style: 'sectionTitle'
    }, {
      text: 'KOBE Uncut GUIDELINES',
      style: 'singleTitle'
    }, {
      text: 'KOBE Uncut PROCESS',
      style: 'header'
    }, {
      image: dataURL,
      style: 'image',
      width: 500
    }, {
      text: 'LEAD TIME',
      style: 'header'
    }, {
      text: '14 days upon receiving this brand fact sheet and logistics from the client.',
      style: 'lastparagraph'
    }, {
      text: 'TIME/DATE OF PUBLISH',
      style: 'header'
    }, {
      text: 'Creators are free to post at any preferred time and day during the campaign period.',
      style: 'lastparagraph'
    }, {
      text: 'SELECTION CRITERIA',
      style: 'header'
    }, {
      text: 'Profiles proposed will be screened for audience credibility on KOBE Patented Influencer Management System (IMS)',
      style: 'subheader'
    }, {
      text: 'For niche requirements (for example, ethnicity, professions) , please opt for storytell packages instead.',
      style: 'lastparagraph'
    }, {
      text: 'CREATORS CONTENT',
      style: 'header'
    }, {
      text: 'All contents created by creators are their organic and authentic reviews from their genuine experience. The contents produced are unvetted and serve as user-generated content. The format and platform of the reviews will depend on the creator’s preference.',
      style: 'lastparagraph'
    }, {
      text: 'CAMPAIGN INFORMATION SHARING',
      style: 'header'
    }, {
      text: 'KOBE will manage the campaign as per information shared by clients in this brand fact sheet. By filling in the brand fact sheet, clients consent to KOBE sharing campaign sensitive information with creators and confirm that all details shared are accurate and final.',
      style: 'lastparagraph'
    }, {
      text: 'LOGISTICS ARRANGEMENT',
      style: 'header'
    }, {
      text: 'It is recommended for our clients to make your own logistics arrangements.',
      style: 'subheader'
    }, {
      text: 'For clients that are unable to handle logistics, KOBE will offer complimentary logistics service for our clients with products (not including perishable goods or items that require special handling or storage) that are below 2kg and parcel size (length + width + height) does not exceed 120cm.',
      style: 'subheader'
    }, {
      text: 'Product has to be sent over to KOBE in 1 shipment before it is disseminated to the creators on your behalf.',
      style: 'subheader'
    }, {
      text: 'There will be a 5 working day turnaround for all logistics arrangements.',
      style: 'subheader'
    }, {
      text: 'KOBE will not be responsible for any damaged or lost parcels.',
      style: 'lastparagraph'
    }, {
      text: 'ADDITIONAL ENGAGEMENT',
      style: 'header'
    }, {
      text: 'Kindly note that any additional engagements listed here are not applicable for KOBE Uncut campaigns and you could opt for Storytell campaign and are chargeable, kindly ensure that requirements are stated clearly with your Client Engagement Representative before launching of the campaign:',
      style: 'subheader'
    }, {
      ul: [
        'Contest giveaway on social media',
        'Photoshoot for client',
        'Video appearance in client’s own production',
        'Usage of photos/videos from creators as Ads online or offline',
        'Promo Code Shoutout',
        'Link in Bio/Swipe Up'
      ],
      style: 'lastparagraph'
    })
    let brandSheetSections = campaignConfig.brandSheetAOKFormSections
    for (let section of brandSheetSections.sectionOne.fields) {
      if (section.type === 'textbox' || section.type === 'textarea') {
        content.push({
          text: section.label,
          style: 'header'
        }, {
          text: brandSheet[section.name],
          style: 'lastparagraph'
        })
      }
      if (section.type === 'file') {
        content.push({
          text: section.label,
          style: 'header'
        })
        if (brandSheet[section.name].length > 0) {
          for (let attachFile of brandSheet[section.name]) {
            if (attachFile.type === 'image/jpeg' || attachFile.type === 'image/png') {
              let dataURL = await utils.func.toDataURL(attachFile.url)
              content.push({
                image: dataURL,
                width: 200,
                style: 'image'
              })
            } else {
              content.push({
                text: 'Click to view',
                link: attachFile.url,
                color: 'blue',
                style: 'lastparagraph'
              })
            }
          }
        } else {
          content.push({
            text: '-',
            style: 'lastparagraph'
          })
        }
      }
    }
    return content
  },
  async generateKobeLite(content, brandSheet) {
    // let url = utils.func.constructWebImageURL('/static/img/brand_sheet/aok_bg.png');
    // let dataURL = await utils.func.toDataURL(url)
    content.push({
      text: 'KOBE Lite - BRAND FACT SHEET',
      style: 'sectionTitle'
    }, {
      text: 'KOBE Lite GUIDELINES',
      style: 'singleTitle'
    }, {
      text: 'LEAD TIME',
      style: 'header'
    }, {
      text: '14 days upon receiving this brand fact sheet and logistics from the client.',
      style: 'lastparagraph'
    }, {
      text: 'TIME/DATE OF PUBLISH',
      style: 'header'
    }, {
      text: 'Creators are free to post at any preferred time and day during the campaign period.',
      style: 'lastparagraph'
    }, {
      text: 'CREATORS CONTENT',
      style: 'header'
    }, {
      text: 'All contents created by creators are their organic and authentic reviews from their genuine experience. The contents produced are unvetted and serve as user-generated content. The format and platform of the reviews will depend on the creator’s preference.',
      style: 'lastparagraph'
    }, {
      text: 'CAMPAIGN INFORMATION SHARING',
      style: 'header'
    }, {
      text: 'By filling in the brand fact sheet, clients consent to KOBE sharing campaign sensitive information with creators and confirm that all details shared are accurate and final.',
      style: 'lastparagraph'
    })
    let brandSheetSections = campaignConfig.brandSheetAOKFormSections
    for (let section of brandSheetSections.sectionOne.fields) {
      if (section.type === 'textbox' || section.type === 'textarea') {
        content.push({
          text: section.label,
          style: 'header'
        }, {
          text: brandSheet[section.name],
          style: 'lastparagraph'
        })
      }
      if (section.type === 'file') {
        content.push({
          text: section.label,
          style: 'header'
        })
        if (brandSheet[section.name].length > 0) {
          for (let attachFile of brandSheet[section.name]) {
            if (attachFile.type === 'image/jpeg' || attachFile.type === 'image/png') {
              let dataURL = await utils.func.toDataURL(attachFile.url)
              content.push({
                image: dataURL,
                width: 200,
                style: 'image'
              })
            } else {
              content.push({
                text: 'Click to view',
                link: attachFile.url,
                color: 'blue',
                style: 'lastparagraph'
              })
            }
          }
        } else {
          content.push({
            text: '-',
            style: 'lastparagraph'
          })
        }
      }
    }
    return content
  },
  async generateUGC(content, brandSheet) {
    let url = utils.func.constructWebImageURL('/static/img/brand_sheet/ugc_process.png');
    let dataURL = await utils.func.toDataURL(url)
    content.push({
      text: 'UGC (User-Generated-Content) Videos Application Form',
      style: 'sectionTitle'
    }, {
      text: 'I am aware that kobe’s full service of S$15k and up, includes: ',
      style: 'subheader'
    }, {
      ul: [
        'Marketing goal, objective, and influence strategy consultation, incorporating the availability heuristic, bandwagon effect, and clustering effect for cognitive and emotive influence.',
        'Development of social media content concepts and strategies using 7X award-winning A.U.D.I framework.',
        'Curated creator identification through patented proprietary software, unveiling deep insights into social performance, audience demographics, and creator interest and personality profiling.',
        'Comprehensive creator relationship management services, including content curation, quality assurance, vetting and scheduling.',
        'Tailored content direction and brief design aligned with marketing objectives, encompassing recommendations for hashtags, captions, content direction, platform selection, optimal timing, and social SEO optimization.',
        'Access to dedicated account managers, strategy planners, and community curators, providing expert recommendations and support.'
      ],
      style: 'lastparagraph'
    }, {
      text: 'Lead time: 4 weeks',
      style: 'subheader'
    }, {
      text: 'To proceed with UGC videos application, please complete the following.',
      style: 'subheader'
    }, {
      text: brandSheet.ugcVideo || '',
      style: 'lastparagraph'
    }, {
      text: 'Includes:',
      style: 'subheader'
    }, {
      ul: [
        'Utilization and exposure to a nano-reviewer base of 10,000 individuals with follower counts up to 3,000.',
        'Guidance and assistance in the creation of email invitations for reviewer outreach and engagement.',
        'Immediate notifications when content is posted, with seamless collection of content assets for future use.',
        'Direct access to reviewer contact information for the purpose of building relationships and facilitating additional collaborations.'
      ],
      style: 'lastparagraph'
    }, {
      image: dataURL,
      style: 'image',
      width: 500
    }, {
      text: 'TIME/DATE OF PUBLISH',
      style: 'header'
    }, {
      text: 'Creators are free to post at any preferred time and day during the campaign period.',
      style: 'lastparagraph'
    }, {
      text: 'INFLUENCER SELECTION',
      style: 'header'
    }, {
      text: 'Influencer selection is interest and response based. Based on what you complete within this form, the information will be distributed to 10,000 individuals with follower counts up to 3,000. The interested recipients will respond accordingly.You are not allowed to modify the requirements of creator quality, quantity, specification.',
      style: 'lastparagraph'
    }, {
      text: 'CREATORS CONTENT',
      style: 'header'
    }, {
      text: 'All contents created by creators are their organic and authentic reviews from their genuine experience. The contents produced are unvetted and serve as user-generated content. The format and platform of the reviews will depend on the creator’s preference.',
      style: 'lastparagraph'
    }, {
      text: 'INFORMATION SHARING',
      style: 'header'
    }, {
      text: 'KOBE will manage the campaign as per information shared by clients in this brand fact sheet. By filling in the brand fact sheet, clients consent to KOBE sharing campaign sensitive information with creators and confirm that all details shared are accurate and final.',
      style: 'lastparagraph'
    }, {
      text: 'LOGISTICS ARRANGEMENT',
      style: 'header'
    }, {
      text: 'For products',
      style: 'subheader'
    }, {
      ul: [
        'Client to send products to creators directly for free',
        'Client to arrange a pick-up point for creators to collect the products directly',
        'Creator can make the purchase of product with attached receipt for 100% reimbursement from client'
      ],
      style: 'lastparagraph'
    }, {
      text: 'For experience',
      style: 'subheader'
    }, {
      ul: [
        'Creator attend the experience directly and client to verify',
        'Creator can make the purchase of experience with attached receipt for 100% reimbursement from client'
      ],
      style: 'lastparagraph'
    }, {
      text: 'UGC VIDEOS TRACKING',
      style: 'header'
    }, {
      text: 'You will receive email notification via your email address provided below each time a creator submits their content. The campaign concludes once the number of UGC videos achieves the number agreed.',
      style: 'lastparagraph'
    }, {
      text: 'POST CAMPAIGN',
      style: 'header'
    }, {
      text: 'You will have direct access to creator contact information for the purpose of relationship building, additional collaborations. Kobe will assume a non-interventionist role and will not levy any charges or engage in mediation with respect to the relationship. You are granted unrestricted discretion to communicate and negotiate according to your preferences.',
      style: 'lastparagraph'
    })
    let brandSheetSections = campaignConfig.brandSheetAOKFormSections
    for (let section of brandSheetSections.sectionOne.fields) {
      if (section.type === 'textbox' || section.type === 'textarea' || section.type === 'radio') {
        content.push({
          text: section.label,
          style: 'header'
        }, {
          text: brandSheet[section.name],
          style: 'lastparagraph'
        })
      }
      if (section.type === 'custom') {
        content.push({
          text: section.label,
          style: 'header'
        })
        // set sample video content url, files
        if (section.name === 'sampleVideoContent') {
          if (typeof brandSheet.sampleVideoContent === 'string') {
            content.push({
              text: brandSheet.sampleVideoContent,
              style: 'lastparagraph'
            })
          }
          if (typeof brandSheet.sampleVideoContent === 'object') {
            if (brandSheet.sampleVideoContent.length) {
              for (let ct of brandSheet.sampleVideoContent) {
                content.push({
                  text: ct.link,
                  link: ct.link,
                  color: 'blue',
                  style: 'lastparagraph'
                })
              }
            }
          }
          if (brandSheet.sampleVideoContentFiles.length) {
            for (let attachFile of brandSheet.sampleVideoContentFiles) {
              content.push({
                text: 'Click to view',
                link: attachFile.url,
                color: 'blue',
                style: 'lastparagraph'
              })
            }
          }
        }
        // set marketing collaborated url, fiels
        if (section.name === 'marketingCollaterals') {
          if (typeof brandSheet.marketingURL === 'object') {
            if (brandSheet.marketingURL.length) {
              for (let ct of brandSheet.marketingURL) {
                content.push({
                  text: ct.link,
                  link: ct.link,
                  color: 'blue',
                  style: 'lastparagraph'
                })
              }
            }
          }
          if (brandSheet.marketingCollaterals.length) {
            for (let attachFile of brandSheet.marketingCollaterals) {
              content.push({
                text: 'Click to view',
                link: attachFile.url,
                color: 'blue',
                style: 'lastparagraph'
              })
            }
          }
        }
        // if (section.name === 'sampleVideoContent') {
        //   // if sample video content, use files variable name and no need title header
        //   section.name = 'sampleVideoContentFiles'
        // } else {
        //   content.push({
        //     text: section.label,
        //     style: 'header'
        //   })
        // }
        // if (brandSheet[section.name].length > 0) {
        //   for (let attachFile of brandSheet[section.name]) {
        //     if (attachFile.type === 'image/jpeg' || attachFile.type === 'image/png') {
        //       let dataURL = await utils.func.toDataURL(attachFile.url)
        //       content.push({
        //         image: dataURL,
        //         width: 200,
        //         style: 'image'
        //       })
        //     } else {
        //       content.push({
        //         text: 'Click to view',
        //         link: attachFile.url,
        //         color: 'blue',
        //         style: 'lastparagraph'
        //       })
        //     }
        //   }
        // } else {
        //   content.push({
        //     text: '-',
        //     style: 'lastparagraph'
        //   })
        // }
      }
    }
    return content
  },
  async generateStoryTell(content, brandSheet) {
    let userGenders = campaignConfig.userGenderDisplay
    let url = utils.func.constructWebImageURL('/static/img/brand_sheet/storytell_bg.jpg');
    let dataURL = await utils.func.toDataURL(url)
    content.push({
      text: 'STORYTELL - BRAND FACT SHEET',
      style: 'sectionTitle'
    }, {
      image: dataURL,
      style: 'image',
      width: 500
    })
    let brandSheetSections = campaignConfig.brandSheetFormSections
    // Section One
    let sectionOne = brandSheetSections.sectionOne
    content.push({
      text: sectionOne.title,
      style: 'singleTitle'
    }, {
      text: sectionOne.subtitle,
      style: 'singleTitle'
    })
    for (let section of sectionOne.fields) {
      if (section.type === 'textbox' || section.type === 'textarea') {
        if (section.name === 'mobilePhone') {
          content.push({
            text: 'Mobile No',
            style: 'header'
          }, {
            text: brandSheet[section.name],
            style: 'lastparagraph'
          })
        } else {
          content.push({
            text: section.label,
            style: 'header'
          }, {
            text: brandSheet[section.name],
            style: 'lastparagraph'
          })
        }
      }
    }
    // Section Two
    let sectionTwo = brandSheetSections.sectionTwo
    content.push({
      text: sectionTwo.title,
      style: 'middleHeader'
    })
    for (let section of sectionTwo.fields) {
      if (section.type === 'textbox' || section.type === 'textarea') {
        if (section.name === 'campaignBudget') {
          content.push({
            text: section.label,
            style: 'header'
          }, {
            text: brandSheet.budgetCurrency ? `${brandSheet.budgetCurrency} ${brandSheet.campaignBudget}` : brandSheet.campaignBudget,
            style: 'lastparagraph'
          })
        } else {
          content.push({
            text: section.label,
            style: 'header'
          }, {
            text: brandSheet[section.name],
            style: 'lastparagraph'
          })
        }
      }
    }
    // Section Three
    let sectionThree = brandSheetSections.sectionThree
    content.push({
      text: sectionThree.title,
      style: 'middleHeader'
    })
    for (let section of sectionThree.fields) {
      content.push({
        text: section.label,
        style: 'header'
      })
      if (section.type === 'textbox' || section.type === 'textarea') {
        if (section.name === 'keyInsights' || section.name === 'wouldLike' ||
        section.name === 'dontWant' || section.name === 'lookAlike') {
          content.push({
            text: brandSheet[section.name].join('\n'),
            style: 'lastparagraph'
          })
        } else {
          content.push({
            text: brandSheet[section.name],
            style: 'lastparagraph'
          })
        }
      }
      if (section.type === 'checkbox') {
        content.push({
          text: brandSheet[section.name].join(', '),
          style: 'lastparagraph'
        })
      }
      if (section.type === 'select') {
        if (section.name === 'gender') {
          let gender = userGenders.find(gender => gender.value === brandSheet[section.name])
          content.push({
            text: gender.text,
            style: 'lastparagraph'
          })
        }
      }
      if (section.type === 'file') {
        if (brandSheet[section.name].length > 0) {
          for (let attachFile of brandSheet[section.name]) {
            if (attachFile.type === 'image/jpeg' || attachFile.type === 'image/png') {
              let dataURL = await utils.func.toDataURL(attachFile.url)
              content.push({
                image: dataURL,
                width: 200,
                style: 'image'
              })
            } else {
              content.push({
                text: 'Click to view',
                link: attachFile.url,
                color: 'blue',
                style: 'lastparagraph'
              })
            }
          }
        } else {
          content.push({
            text: '-',
            style: 'lastparagraph'
          })
        }
      }
    }
    return content
  },
  BFSConfig() {
    return {
      footer: function(currentPage, pageCount) {
        return {
          margin: 10,
          columns: [
            {
              fontSize: 9,
              text: [
                {
                  text: '--------------------------------------------------------------------------' +
                  '\n',
                  margin: [0, 20]
                },
                {
                  text: currentPage.toString() + ' of ' + pageCount
                }
              ],
              alignment: 'center'
            }
          ]
        };
        // return currentPage.toString() + ' of ' + pageCount;
      },
      content: [
        {
          image: config.kobeLogoDataURL,
          width: 60,
          style: 'logo',
          alignment: 'left'
        }
      ],
      styles: {
        sectionTitle: {
          alignment: 'center',
          bold: true,
          fontSize: 20,
          marginTop: 20,
          // marginLeft: 9,
          marginBottom: 20,
          padding: 5
        },
        singleTitle: {
          fontSize: 13,
          marginBottom: 15,
          bold: true
        },
        image: {
          marginBottom: 15
        },
        header: {
          fontSize: 12,
          bold: true,
          marginBottom: 2
        },
        middleHeader: {
          fontSize: 13,
          bold: true,
          marginTop: 5,
          marginBottom: 3
        },
        subheader: {
          fontSize: 12,
          marginBottom: 10
        },
        lastparagraph: {
          fontSize: 12,
          marginBottom: 15
        },
        footer: {
          alignment: 'center'
        }
      },
      defaultStyle: {
        font: 'Arial'
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/views/Campaign/campaignPDF.js